<div class="main-container">
  <section class="top-section">
    <img src="/assets/logo/logo-full-green.png" alt="" />
    <label for="">{{ companyName }}</label>
  </section>
  <br />
  <section class="" *ngIf="planSelected">
    <go-back (click)="planSelected = null"></go-back>
  </section>

  <!-- <section class="slide-container" *ngIf="!currentUser.blocked">
    <img src="/assets/sing-up/4.png" alt="" />
  </section> -->

  <section class="sing-up-title-wrapper">
    <h1>Pick a Plan</h1>
    <label for="">Please choose a plan</label>
    <div class="trial-text">First 30 days are free.</div>
    <!-- <div class="trial-text">30-Day Free Trial Available for First-Time Users on All Plans.</div> -->
  </section>

  <!-- <section class="log-out">
    <label for="" class="email">{{ currentUser.email }}</label>
    <span (click)="logOut()"> Log out </span>
    <mat-icon class="user-icon" mat-raised-button (click)="openBottomSheet()"
      >person</mat-icon
    >
    <ng-template let-bottomSheetRef="bottomSheetRef" #templateBottomSheet>
      <div class="bottom-sheet">
        <div class="">
          <label for="">{{ currentUser.email }}</label>

          <gbui-button (click)="logOut()" class="">Log out</gbui-button>
        </div>
      </div>
    </ng-template>
  </section> -->
  <!--
      **
      * Starts Memberships container
      **
     -->
  <ng-template [ngIf]="(membershipsLoading$ | async) || (payMembershipLoading$ | async)">
    <div class="loader-container">
      <loader></loader>
    </div>
  </ng-template>
  <ng-template [ngIf]="memberships$ | async" let-memberships>
    <section class="memberships-cards" *ngIf="!planSelected">
      <div class="cards" *ngFor="let item of memberships">
        <div class="">
          <h1>{{ item.name }}</h1>

          <div class="free-trial-strip">First 30 days free</div>

          <!-- <label class="description">{{ item?.description }}</label> -->
          <label class="price">${{ numberFormat(item.price) }}</label>
          <label class="interval">{{ item.recurrentInterval }}</label>
          <div class="buttons-container">
            <gbui-button class="buttons-outline" (click)="selectPlan(item)">Pay subscription</gbui-button>
          </div>
          <label class="description">{{item.description}}</label>
        </div>
      </div>
    </section>
  </ng-template>
</div>

<ng-template [ngIf]="planSelected && !canDismissCard">
  <div class="main-container subscribe-wrapper">
    <div class="memberships-cards membership-wrapper">
      <div class="cards">
        <div class="">
           <h1>{{ planSelected.name }}</h1>
 
          <div class="free-trial-strip">First 30 days free</div>

           <!-- <label class="description">{{
             planSelected?.description
           }}</label> -->
           <label class="price">${{ numberFormat(planSelected.price) }}</label>
          <label class="interval">{{ planSelected.recurrentInterval }}</label>
          <label class="description">{{planSelected.description}}</label>
        </div>
      </div>
    </div>
    <section class="add-card-form" [formGroup]="paymentMethodForm" id="paymentMethodForm">
      <div class="card-information">
        <label class="title">Card information</label>
        <div class="inputs-container">
          <div class="input-container">
            <label class="input-label">Cardholder’s Name</label>
            <gbui-input class="inputs card-holder-name" simple formControlName="nameOfCardHolder"
              placeholder="Enter your cardholder’s name"></gbui-input>
          </div>
          <div class="input-container">
            <label class="input-label">Card’s Number</label>
            <div class="simulate-input">
              <div id="cardNumber" #cardNumber></div>
            </div>
          </div>
          <div class="input-container">
            <label class="input-label">Expiration Date</label>
            <div class="d-shorts">
              <div class="simulate-input w-50">
                <div id="cardExpiry" #cardExpiry></div>
              </div>
            </div>
          </div>
          <div class="input-container">
            <label class="input-label">CVV</label>
            <div class="d-shorts">
              <div class="simulate-input w-50">
                <div id="cardCvc" #cardCvc></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <gbui-animated-height-display class="flex-container-error" [display]="cardError">
        <p class="error-text" gbui-feedback-text="danger">{{ cardError }}</p>
      </gbui-animated-height-display>
      <div class="button-container bottom-button">
        <gbui-button [disabled]="paymentMethodForm.controls['nameOfCardHolder'].invalid" simple [busy]="
            checkingStripeToken ||
            (saveCardLoading$ | async) ||
            ((payMembershipLoading$ | async) ?? false)
          " (click)="createStripeToken()">Subscribe</gbui-button>
      </div>
    </section>
  </div>
</ng-template>